import { makeObservable } from "mobx";
import type { TBrand } from "./types";

export class BrandReportBaseModel {
  id: TBrand["id"];
  name: TBrand["name"];
  image?: NonNullable<TBrand["image"]>["urls"]["thumbnail"];

  gross_income_for_date_range: TBrand["gross_income_for_date_range"];

  constructor(src: TBrand) {
    makeObservable(this);
    this.id = src.id;
    this.name = src.name;
    this.image = src.image?.urls?.thumbnail ?? undefined;
    this.gross_income_for_date_range = src.gross_income_for_date_range;
  }
}
